import { ActivityModel, GenericActivity } from '../Activities';

function mergeEqualAnnotations(
  annotations: ReturnType<GenericActivity>['annotations'],
): ReturnType<GenericActivity>['annotations'] {
  return annotations.reduce((result: ReturnType<GenericActivity>['annotations'], next) => {
    const equalItem = result.find((k) => k.text === next.text);
    if (equalItem) {
      equalItem.CADSubjects.push(...next.CADSubjects);
      return result;
    }
    result.push(next);
    return result;
  }, []);
}

export const genericActivities: Record<string, GenericActivity> = {
  InstallComponent: (activity: ActivityModel) => ({
    description: 'Install part',
    constantAttributes: {},
    requiredAttributes: [],
    recordDescription: 'Install {{model.name}}',
    records: {},
    unitCost: 3,
    tools: [],
    permissions: ['Assembly'],
    processSpecification: [],
    materials: activity.subjects.map((sub) => sub.ref.join(';')),
    consumables: [],
    totalCost: 3 * activity.count,
    standardOperatingProcedure: 'SOP',
    annotations: mergeEqualAnnotations(
      activity.subjects.map((sub, i) => ({
        CADSubjects: [{ ref: sub.ref, offsetPosition: sub.offsetPosition }],
        text: `install ${sub.ref}`,
        icon: 'install',
        colorKey: `color${i}`,
      })),
    ),
  }),
  InspectDimension: (activity) => ({
    description: 'Inspect dimension',
    recordDescription: 'Inspect {{typeOfDimension}} to be within {{minimum}} and {{maximum}}',
    records: {},
    unitCost: 1,
    tools: [],
    permissions: ['SimpleMeasure'],
    processSpecification: [],
    annotations: mergeEqualAnnotations(
      activity.subjects.map((sub) => ({
        CADSubjects: [{ ref: sub.ref }],
        text: 'Measure',
        colorKey: '1',
        icon: 'measure',
      })),
    ),
    materials: [],
    consumables: [],
    totalCost: activity.count * 1,
    standardOperatingProcedure: 'SOP',
  }),
  DrillHole: (activity) => ({
    description: 'Drill hole',
    records: {},
    recordDescription: 'Drill {{model.dimension}}',
    unitCost: 1,
    tools: ['Drill'],
    permissions: ['Assembly'],
    processSpecification: [],
    annotations: mergeEqualAnnotations(
      activity.subjects.map((sub) => ({
        CADSubjects: [{ ref: sub.ref, offsetPosition: sub.offsetPosition }],
        text: 'Drill',
        colorKey: '1',
        icon: 'drill',
      })),
    ),
    materials: [],
    consumables: [],
    totalCost: activity.count * 1,
    standardOperatingProcedure: 'SOP',
  }),
  InstallBolt: (activity) => ({
    description: 'Install bolt',
    records: {
      wrenchId: {
        type: 'text',
        value: null,
      },
    },
    recordDescription: 'Install {{model.name}} to torque: {{Torque}}',
    unitCost: 1,
    tools: ['TorqueTool'],
    permissions: ['Assembly'],
    processSpecification: [],
    annotations: mergeEqualAnnotations(
      activity.subjects.map((sub) => ({
        CADSubjects: [{ ref: sub.ref, offsetPosition: sub.offsetPosition }],
        text: 'Torque',
        colorKey: '1',
        icon: 'wrench',
      })),
    ),
    materials: [],
    consumables: [],
    totalCost: activity.count * 1,
    standardOperatingProcedure: 'SOP',
  }),
};
